export default __webpack_public_path__ + "1b9acae82afab1dfe43758c51accfc0e.svg";